import { RouteRecordRaw } from 'vue-router'
import common from './common'
import nopage from './nopage'
const routes: Array<RouteRecordRaw> = [
  ...common,
  ...nopage
]

export default routes